import React, { useState, useEffect } from 'react';
import './About.css';
import image1 from './about-img/fkkkk 222.png'
import image2 from './about-img/fk werk.png'
import Aos from 'aos';
import 'aos/dist/aos.css'



const About = () => {
  const NumberCounter = ({ start, end, duration }) => {
    const [count, setCount] = useState(start);
  
    useEffect(() => {
      const range = end - start;
      const increment = range / (duration / 10); // Increment step
      let current = start;
  
      const timer = setInterval(() => {
        current += increment;
        if (current >= end) {
          current = end; // Ensure it doesn't exceed the end value
          clearInterval(timer);
        }
        setCount(Math.floor(current)); // Update state with rounded value
      }, 10); // Update every 10ms
  
      return () => clearInterval(timer); // Cleanup timer on component unmount
    }, [start, end, duration]);
  
    return <div >{count.toLocaleString()}</div>;
  };

  useEffect(()=>{
    Aos.init({duration:1000});
  },[])

  return (
    <div className="about-main" id='about'>
      {/* <div className="about-increment">
        <div className="increment" data-aos="zoom-in">
          <p><NumberCounter start={1} end={7} duration={3000} />K+</p>
          <span>Charging Session Initiated</span>
        </div>
        <div className="increment" data-aos="zoom-in">
          <p><NumberCounter start={1} end={12} duration={3000} />K+</p>
          <span>Charging Station In Network</span>
        </div>
        <div className="increment" data-aos="zoom-in">
          <p><NumberCounter start={1} end={80} duration={3000} /> %</p>
          <span>Eco-Friendly Charging Station</span>
        </div>
        <div className="increment" data-aos="zoom-in">
          <p><NumberCounter start={1} end={123} duration={3000} /> +</p>
          <span>Units Available In This Region</span>
        </div>
      </div> */}
      <div className="about-contents">
        <div className="content-img" data-aos="fade-up">
          <img className='img1' src={image1} alt="" />
          <img className='img2' src={image2} alt="" />
        </div>
        <div className="aboutus-content">
          <div className="about-us" data-aos="fade-up">
            <p>About Us </p>
            <div className="line"></div>
          </div>
          <div className="contents-main">
            <div className="content-head" data-aos="fade-up">
              <p>Complete Charging Solutions for All
              Electric Vehicles!</p>
            </div>
            <div className="solution-content" data-aos="fade-up">
              <p> AIZO Plug, founded in 2015, is a premier provider of electric vehicle (EV) charging solutions in
 India. We have been focused on promoting sustainable energy practices and facilitating the
 transition to clean, eco-friendly transportation.</p>
            </div>
            <div className="content-card">
              <div className="card" data-aos="fade-up">
                <div className="card-icon">
                <i class="fa-solid fa-wrench"></i>
                </div>
                <div className="card-head">
                  <p>Modern Design</p>
                </div>
                <div className="card-content">
                  <p>We provide modern, sleek, and
 functional designs for our EV charging
 stations.</p>
                </div>
              </div>
              <div className="card" data-aos="fade-up">
                <div className="card-icon">
                <i class="fa-solid fa-network-wired"></i>
                </div>
                <div className="card-head">
                  <p>Nationwide Support</p>
                </div>
                <div className="card-content">
                  <p>We offer nationwide support, ensuring
                  reliable assistance across India</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;